<template>
	<ul id="demo" class="relative navheader-item">
		<li v-for="(item,index) in this.oData.children" :class="{current:cur_pos==index}"
			@mouseenter="mouseenter(index)" @mouseleave="mouseleave(index)">
			<router-link :to="item.path" @click.native="click(index)">{{item.name}}</router-link>
			<div class="absolute product_nav hide" v-if="item.children!=null">
				<ul>
					<li v-for="nav in item.children"><a :href="nav.path" target="_blank">{{nav.name}}</a></li>
					<div class="clear"></div>
				</ul>
			</div>
		</li>
	</ul>
</template>

<script>
	import bus from '@/assets/js/bus';
	import './index.less';
	export default {
		name: 'item',
		props: {
			oData: {
				type: Object,
				default () {
					return {}
				}
			}
		},
		data() {
			return {
				cur_pos: 0,
			}
		},
		methods: {
			//点击导航，样式改变
			click(index) {
				if (index != 2) {
					bus.$emit('nav', index);

				}
			},
			//hover效果
			mouseenter(index) {
				if (index == 2) {
					$('.product_nav').removeClass('hide')
				}
			},
			//hover移除效果
			mouseleave(index) {
				if (index == 2) {
					$('.product_nav').addClass('hide')
				}
			},
			//刷新页面时，不改变导航的位置
			cur_loaction() {
				//得到当前的path，再与数组里的path比较
				var path = this.$route.path;
				console.log(path)
				var pathArr = path.split('/');
				// console.log(pathArr)

				if (pathArr.length == 2) {
					//循环数组
					this.oData.children.forEach((item, index, err) => {
						//console.log(item.path,path)
						if (path == item.path) {
							return this.cur_pos = index;
						}
					})
				} else if (pathArr.length == 3) {
					var nowpath = '/' + pathArr[pathArr.length - 2];

					//循环数组
					this.oData.children.forEach((item, index, err) => {

						if (nowpath == item.path) {
							return this.cur_pos = index;
						}
					})
				} else {
					var nowpath = '/' + pathArr[pathArr.length - 3];

					//循环数组
					this.oData.children.forEach((item, index, err) => {

						if (nowpath == item.path) {
							return this.cur_pos = index;
						}
					})
				}
			}
		},
		components: {

		},
		created() {
			//路由实例对象
			//console.log(this.$router);
			//路由信息对象
			//console.log(this.$route);
			this.cur_loaction();
			bus.$on('nav', (index) => {
				this.cur_pos = index;
			})
		},
		updated() {
			this.cur_loaction();
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/navHeader_item/index.vue